var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMk = function SvgMk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21724_19595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21724_19595)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#C03530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 7.08333L8.33333 0H11.6667L10.4167 7.08333H9.58333Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 4.16667L7.5 8.33333L7.08333 8.75L0.833333 5.41667L1.66667 4.16667Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 10.4167V9.58333L0 9.16667V10.8333L7.08333 10.4167Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 11.6667L7.5 11.25L0.833333 14.5833L1.66667 16.25L7.91667 11.6667Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 20L9.58333 12.9167H10.4167L11.6667 20H8.33333Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.25L12.0833 11.6667L18.3333 15.8333L19.1667 14.5833L12.5 11.25Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 9.58333V10.4167L20 11.25V9.16667L12.9167 9.58333Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33333V8.75L19.1667 5.41667L18.3333 3.75L12.5 8.33333Z",
    fill: "#FAE74D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.9987,
    cy: 10.0007,
    r: 4.16667,
    fill: "#C03530"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.9987,
    cy: 10.0007,
    r: 2.91667,
    fill: "#FAE74D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mk.888cd92a7fb3669bd67709c828f8cda0.svg";